export class UserSearchPreferences {
  private filterText: string;
  private transactionalManagementAutoPageRefresh: boolean;

  constructor() {
    this.transactionalManagementAutoPageRefresh = false;
  }

  public getFilterText(): string {
    return this.filterText;
  }

  public setFilterText(value: string): void {
    this.filterText = value;
  }

  public getTransactionalManagementAutoPageRefresh(): boolean {
    return this.transactionalManagementAutoPageRefresh;
  }

  public setTransactionalManagementAutoPageRefresh(value: boolean): void {
    this.transactionalManagementAutoPageRefresh = value;
  }
}
